module.exports = __webpack_public_path__ + "static/img/piece_2100.d0b3684.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/piece/piece_2100.png
// module id = Q8il
// module chunks = 0